/* eslint-disable camelcase */
import React from 'react';
import { useHistory, Route, Switch, Redirect, useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { PERMISSION, PRIVATE_PATH } from '../../../constants';
import SidebarWrapper from '../../../sections/SidebarWrapper';
import FlexProfessionalsEmployeeDetails from './FlexProfessionalsEmployeeDetails';
import FlexProfessionalCredentials from './credentials/FlexProfessionalCredentials';
import FlexProfessionalLocations from './locations/FlexProfessionalLocations';
import { user } from '../../../redux/user';
import ProtectedRoute from '../../../sections/ProtectedRoute';
import utils from '../../../utils/utils';
import { useGetProfessionalQuery } from '../../../redux/managementCompanyWorkforce';

const FlexProfessionalDetails = () => {
	const history = useHistory();

	const { caregiverId: professionalId, managementCompanyId } = useParams();
	const userData = useSelector(user, shallowEqual);
	const { data: professional } = useGetProfessionalQuery(
		{ managementCompanyId, caregiverId: professionalId },
		{
			refetchOnMountOrArgChange: true
		}
	);
	const sidebarItems = [
		{
			label: 'Employee Details',
			editTitle: 'Edit Details',
			isEditing: false,
			path: `${PRIVATE_PATH.WORKFORCE_PAGE}/${managementCompanyId}/professionals/${professionalId}/employee-details`,
			editText: 'Edit Details',
			className: 'details-header'
		},
		{
			label: 'Credentials',
			editTitle: professional
				? `Credentials - ${professional?.first_name || ''} ${professional?.last_name || ''}`
				: 'Credentials',
			isEditing: true,
			path: `${PRIVATE_PATH.WORKFORCE_PAGE}/${managementCompanyId}/professionals/${professionalId}/credentials`,
			isDisabled: !utils.isAuthorizedExact(
				PERMISSION.WORKFORCE_CREDENTIALS_VIEW,
				userData.managementCompanyPermissions[managementCompanyId]
			),
			className: 'flex-credentials-title'
		},
		{
			label: 'Locations',
			editTitle: professional
				? `Locations - ${professional?.first_name || ''} ${professional?.last_name || ''}`
				: 'Locations',
			isEditing: true,
			path: `${PRIVATE_PATH.WORKFORCE_PAGE}/${managementCompanyId}/professionals/${professionalId}/locations`,
			isDisabled: !utils.isAuthorizedExact(
				PERMISSION.WORKFORCE_LOCATIONS_VIEW,
				userData.managementCompanyPermissions[managementCompanyId]
			),
			className: 'flex-credentials-title'
		}
	];

	const handleBackToProfessionalsList = () => {
		history.push(PRIVATE_PATH.WORKFORCE_PAGE);
	};

	return (
		<SidebarWrapper
			sidebarTitle="Manage Professional"
			sidebarItems={sidebarItems}
			backTitle="Back to Workforce"
			backAction={handleBackToProfessionalsList}
			className="flex-professionals-sidebar"
		>
			<Switch>
				<ProtectedRoute
					exact
					key="employee-details"
					component={FlexProfessionalsEmployeeDetails}
					pathPermission={PERMISSION.WORKFORCE_PROFESSIONAL_VIEW}
					userPermissions={userData.managementCompanyPermissions[managementCompanyId]}
					path={`${PRIVATE_PATH.WORKFORCE_PAGE}/:managementCompanyId/professionals/:professionalId/employee-details`}
				/>
				<ProtectedRoute
					exact
					path={`${PRIVATE_PATH.WORKFORCE_PAGE}/:managementCompanyId/professionals/:caregiverId/credentials`}
					key="credentials"
					component={FlexProfessionalCredentials}
					pathPermission={PERMISSION.WORKFORCE_CREDENTIALS_VIEW}
					userPermissions={userData.managementCompanyPermissions[managementCompanyId]}
				/>
				<ProtectedRoute
					exact
					path={`${PRIVATE_PATH.WORKFORCE_PAGE}/:managementCompanyId/professionals/:caregiverId/locations`}
					key="locations"
					component={FlexProfessionalLocations}
					pathPermission={PERMISSION.WORKFORCE_LOCATIONS_VIEW}
					userPermissions={userData.managementCompanyPermissions[managementCompanyId]}
					professionalName={`${professional?.first_name || ''} ${professional?.last_name || ''}`}
				/>
				<Route path="/*" render={() => <Redirect to="/404" />} />
			</Switch>
		</SidebarWrapper>
	);
};

export default FlexProfessionalDetails;
